import { render } from "./input.vue?vue&type=template&id=1edc9aa5"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1edc9aa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1edc9aa5', __exports__)) {
    console.log('reload')
    api.reload('1edc9aa5', __exports__)
  }
  
  module.hot.accept("./input.vue?vue&type=template&id=1edc9aa5", () => {
    console.log('re-render')
    api.rerender('1edc9aa5', render)
  })

}


export default __exports__